
import {
    get,
    post,
    del,
    getfile
} from '@/http/request'
import {
    HOST
} from '@/http/config'


//添加余额
export function saveFinancialInformationInquiry(params) {
    return post(`${HOST}financial-information-inquiry/save`, params)
}
// 导入财务数据
export function uploadFinancialInformationInquiry(params) {
    return post(`${HOST}financial-information-inquiry/upload`, params)
}

//财务信息列表
export function getFinancialInformationInquiry(params) {
    return get(`${HOST}/financial-information-inquiry/list`, params)
}
//重置数据
export function deleteFinancialInformationInquiry() {
    return del(`${HOST}/financial-information-inquiry/delete`)
}

//删除财务信息列表
export function closeFinancialInformationInquiry(params) {
    return get(`${HOST}/financial-information-inquiry/delete`, params)
}
// 财务导出模板
export function importTemplate() {
    return getfile(`${HOST}financial-information-inquiry/importTemplate`)
  }








// WEBPACK FOOTER //
// ./src/views/FinancialInformationInquiry/api/api.js